/**
 * SPA origin for API email branding (X-Frontend-Origin header).
 * Brand → template slug map lives in API `api/packages/frontend_branding.py`.
 * Local override: set ``REACT_APP_FRONTEND_ORIGIN`` (e.g. ADREC QA URL) when
 * testing email branding from localhost.
 */
export function getFrontendOrigin() {
    const override = (process.env.REACT_APP_FRONTEND_ORIGIN || "").trim();
    if (override) {
        return override;
    }
    if (typeof window === "undefined") {
        return "";
    }
    return window.location.origin || "";
}
